<template>
  <v-col cols="4" sm="4" md="4">
    <v-card class="mx-auto" height="135">
      <v-list-item three-line>
        <v-list-item-content>
          <div class="overline mb-4">
            UTENTI
          </div>
          <v-list-item-title class="headline mb-1">
            Tot:  <span v-if="totOrgUsers">{{totOrgUsers.data[0].tot}}</span>
          </v-list-item-title>
          <v-list-item-subtitle>Active: <span v-if="totOrgActiveUsers">{{totOrgActiveUsers.data[0].tot}}</span></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import { getOrgStats } from "../../plugins/getAnalysics";

export default {
  name: "OrgDetailData",

  data() {
    return {
      totOrgUsers: null,
      totOrgActiveUsers: null,
    };
  },

  props: {
    orgId: {
      default: () => ({})
    },
  },

  computed: {
    ...mapGetters({
      datesrange: "datesrange",
    }),
  },
 
  methods: {
    async getUsersAnalytics(){
      const totOrgUsers = await getOrgStats({ queryType: 'totUsers', orgId: this.orgId, datesrange: this.datesrange })
      this.totOrgUsers = totOrgUsers

      const totOrgActiveUsers = await getOrgStats({ queryType: 'totActiveUsers', orgId: this.orgId, datesrange: this.datesrange })
      this.totOrgActiveUsers = totOrgActiveUsers
    },
  },

  async mounted(){
    this.getUsersAnalytics();
  },

}
</script>

<style>

</style>